/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';

import genericReducers from '../genericReducer';
import { IReducers } from '..';
import { ICommonResponse, IStudentSportReward } from '../../api/types';
import { GET_STUDENT_SPORT_REWARDS } from '../../actions';
import { StudentDiagnosisState } from './studentDiagnosis';

export type StudentSportRewardsState = ICommonResponse<IStudentSportReward>;

const initialState: StudentSportRewardsState = {
  content: [],
  loading: false,
};
const generic = genericReducers<StudentSportRewardsState>();
const studentSportRewards: IReducers<StudentSportRewardsState> = {
  [GET_STUDENT_SPORT_REWARDS[REQUEST]]: generic.get.request,
  [GET_STUDENT_SPORT_REWARDS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_SPORT_REWARDS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_SPORT_REWARDS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentSportRewards);
